import React, { memo, useCallback } from "react";
import { ChevronLeft } from "react-feather";

const SidebarToggle = memo(({ expanded, onToggle, className = "", sidebarId = "admin-primary-sidebar" }) => {
  const handleKeyDown = useCallback(
    (event) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        onToggle();
      }
    },
    [onToggle]
  );

  return (
    <button
      type="button"
      className={`admin-sidebar-toggle ${
        expanded ? "" : "admin-sidebar-toggle--collapsed"
      } ${className}`.trim()}
      onClick={onToggle}
      onKeyDown={handleKeyDown}
      aria-label={expanded ? "Collapse sidebar" : "Expand sidebar"}
      aria-expanded={expanded}
      aria-controls={sidebarId}
    >
      <span
        className={`admin-sidebar-toggle__icon ${
          expanded ? "" : "admin-sidebar-toggle__icon--collapsed"
        }`}
      >
        <ChevronLeft size={18} strokeWidth={2.25} aria-hidden="true" />
      </span>
    </button>
  );
});

SidebarToggle.displayName = "SidebarToggle";

export default SidebarToggle;
